import axios from "axios";

export function getCheckoutDeliveryInfo(uuid) {
  return new Promise((resolve, reject) => {
    axios
      .get(`/distributor/admin/api/v1/prife/checkout/${uuid}/delivery-info`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
